module.exports = __webpack_public_path__ + "static/media/videoIcon.bff36866.svg";